<template>
	<button
		type="button"
		class="calendar-event v-event-draggable"
		:style="`--event-color: ${status.hexColor}`"
		v-tippy="{ content: tippyLabel }"
		@mousedown.stop="startDrag(event)"
		@click.stop="editDeliverable(event)"
	>
		<span class="event-status" aria-hidden="true"></span>
		<span class="event-label no-select">{{ event.name }}</span>
	</button>
</template>

<script>
	export default {
		name: 'CalendarItem',

		props: ['event','status'],

		components: { },

		data: function() {
			return {};
		},

		methods: {
			startDrag: function(event) {
				this.$emit('start-drag', event);
			},

			editDeliverable: function(event) {
				this.$emit('edit-deliverable', event);
			},
		},

		computed: {
			tippyLabel: function(){
				if(this.event.project){
					return this.event.project.name + " - " + this.event.name;
				}else{
					return this.event.name;
				}
			}
		},
	};
</script>

<style scoped lang="scss">
	.calendar-event {
		position: relative;
		width: 100%;
		min-width: 0;
		min-height: 30px;
		display: flex;
		align-items: center;
		gap: 7px;
		margin-bottom: 4px;
		padding: 4px 7px;
		overflow: hidden;
		border: 1px solid color-mix(in srgb, var(--event-color) 28%, var(--portal-border));
		border-left: 3px solid var(--event-color);
		border-radius: var(--brand-surface-radius, 8px);
		background: color-mix(in srgb, var(--event-color) 8%, var(--portal-surface));
		color: var(--portal-text);
		font: inherit;
		cursor: pointer;
		text-align: left;
	}

	.calendar-event:hover {
		background: color-mix(in srgb, var(--event-color) 13%, var(--portal-surface));
	}

	.event-status {
		width: 7px;
		height: 7px;
		flex: 0 0 7px;
		border-radius: 50%;
		background: var(--event-color);
	}

	.event-label {
		display: block;
		min-width: 0;
		flex: 1;
		overflow: hidden;
		font-size: 11px;
		font-weight: 600;
		line-height: 1.3;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.no-select {
		-webkit-touch-callout: none;
		user-select: none;
	}
</style>
